import espanha from "./espanha.png";
import brasil from "./brasil.png";
import italia from "./italia.png";
import franca from "./franca.png";
import inglaterra from "./inglaterra.png";
import europa from "./europa.png";

export const leaguesImg = {
  brasil,
  italia,
  franca,
  espanha,
  inglaterra,
  europa,
};



// WEBPACK FOOTER //
// ./src/static/img/leagues/index.js